import React from 'react';
import { API_BASE_URL } from '../../store/constans';
import { useNavigate } from 'react-router-dom';

const FlagYacht = ({ yacht }) => {

    const navigate = useNavigate();
    
    const handleClick = (code) => {
        navigate(`/galapagos-cruises/${code}`)
    }

    return (
        <div className={`flex text-white flex-col py-8 justify-between h-[400px] items-center transition-all bg-cover bg-center`} style={{ backgroundImage: `url(${API_BASE_URL}${yacht.image})` }}>
            <h3 className='text-[35px] uppercase font-semibold text-shadow-lg'>{yacht.name}</h3>
            <button
                onClick={() => (handleClick(yacht.code))}
                className=' active:scale-95 transition-all hover:scale-110 duration-300 shadow-md shadow-black text-[15px] md:text-[18px] border border-white px-5 py-2 font-bold rounded-full hover:text-white hover:bg-orange-500 hover:border-white'>
                More info
            </button>
        </div>
    );
};

export default FlagYacht;